const nargs = /\{([0-9a-zA-Z_]+)\}/g

export default function formatString(string = '', options = {}) {
    return string.replace?.(nargs, function replaceArg(match, i, index) {
        var result

        if (string[index - 1] === "{" &&
            string[index + match.length] === "}") {
            return i
        } else {
            result = options?.hasOwnProperty(i) ? options[i] : null
            if (result === null || result === undefined) {
                return ""
            }

            return result
        }
    })
}